import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink, Route, Routes } from "react-router";
import "../../components/Sidebar/Sidebar.scss";
import AdminNotificationConfig from "../../containers/AdminNotificationConfig/AdminNotificationConfig";
import DashboardData from "../../containers/DashboardData/DashboardData";
import Register from "../../containers/RegisterForm/Register/Register";
import { TablesBasePageEC7 } from "../../containers/TablesBasePage/TablesBasePageEC7";
import { TablesBasePageAASHTO } from "../../containers/TablesBasePage/TablesBasePageAASHTO.jsx";
import { TablesBasePageEPD } from "../../containers/TablesBasePage/TablesBasePageEPD.jsx";
import TablesBasePageTragglieder from "../../containers/TablesBasePage/TablesBasePageTragglieder.jsx";
import UsersList from "../../containers/UsersList/UsersList";
import ischebeckFooterLogo from "../../images/Ischebeck_Logo2013_VarA_RGB_1zu1_trans.svg";
import ischebeck_logo_de from "../../images/mikropfahl-online-bemessung.jpg";
import ischebeck_logo_en from "../../images/mikropfahl-online-bemessung_EN.jpg";
import ischebeck_logo_es from "../../images/mikropfahl-online-bemessung_ES.jpg";
import {
  isAllowedToViewRegisterSettings,
  isAllowedToViewTables,
  isAllowedToViewUsers,
} from "../../services/auth/Roles";
import { selectCurrentRoles } from "../../store/slices/auth/authSlice";
import DashboardNavbar from "../Navigation/DashboardNavbar.jsx";

const Dashboard = () => {
  const { t, i18n } = useTranslation("translation");

  const roles = useSelector(selectCurrentRoles);

  return (
    <div className="temp">
      <div className="container-fluid">
        <div className="row">
          <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block sidebar collapse p-0">
            <div className="position-sticky d-flex flex-column min-vh-100">
              <div className="">
                <Image
                  className="logo"
                  src={
                    i18n.language == "de-DE"
                      ? ischebeck_logo_de
                      : i18n.language == "es-ES"
                        ? ischebeck_logo_es
                        : ischebeck_logo_en
                  }
                  alt=""
                />
              </div>
              <div className="links navigation-links flex-column mb-auto">
                <ul className="nav flex-column pt-3 ">
                  {isAllowedToViewUsers(roles) && (
                    <li key={1} className="nav-item navbar-text">
                      <NavLink to="/dashboard/users">{t("navigation.Users")}</NavLink>
                    </li>
                  )}
                  {isAllowedToViewRegisterSettings(roles) && (
                    <li key={2} className="nav-item navbar-text">
                      <NavLink to="/dashboard/registerconfig">
                        {t("navigation.registerMail")}
                      </NavLink>
                    </li>
                  )}
                  {isAllowedToViewTables(roles) && (
                    <>
                      <li key={3} className="nav-item navbar-text">
                        <NavLink to="/dashboard/products">{t("navigation.products")}</NavLink>
                      </li>
                      <li key={4} className="nav-item navbar-text">
                        <NavLink to="/dashboard/eurocodedata">
                          {t("navigation.datatablesEC7")}
                        </NavLink>
                      </li>
                      <li key={5} className="nav-item navbar-text">
                        <NavLink to="/dashboard/aashtodata">
                          {t("navigation.datatablesAASHTO")}
                        </NavLink>
                      </li>
                      {/* <li key={6} className="nav-item navbar-text">
                        <NavLink to="/dashboard/edpdata">
                          {t("navigation.datatablesEPD")}
                        </NavLink>
                      </li> */}
                      <li key={6} className="nav-item navbar-text">
                        <NavLink to="/dashboard/statistics">{t("navigation.Statistics")}</NavLink>
                      </li>
                    </>
                  )}
                </ul>
              </div>
              <div
                style={{
                  textAlign: "center",
                  backgroundColor: "white",
                  padding: "50px 0 50px 0",
                }}
              >
                <Image className="logo1" src={ischebeckFooterLogo} alt="" />
              </div>
            </div>
          </nav>

          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 p-0">
            <DashboardNavbar />

            <Routes>
              <Route path="register-form" element={<Register />} />
              <Route path="statistics" element={<DashboardData />} />
              <Route path="users" element={<UsersList />} />
              <Route path="registerConfig" element={<AdminNotificationConfig />} />
              <Route path="products" element={<TablesBasePageTragglieder />} />
              <Route path="eurocodedata" element={<TablesBasePageEC7 />} />
              <Route path="aashtodata" element={<TablesBasePageAASHTO />} />
              {/* <Route path="edpdata" element={<TablesBasePageEPD />} /> */}
            </Routes>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
